var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2A37",
    d: "M14.5.25h-9A5.256 5.256 0 0 0 .25 5.5v9a5.256 5.256 0 0 0 5.25 5.25h9a5.256 5.256 0 0 0 5.25-5.25v-9A5.256 5.256 0 0 0 14.5.25M10 14.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m5.625-9a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25M13 10a3 3 0 1 1-5.999 0A3 3 0 0 1 13 10"
  })));
};
export default SvgInstagram;